import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { MegaMenu } from './MegaMenu';
import { servicesMenu } from '../data/mock';

export const Navbar = ({ onOpenForm }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#0A1F44] shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center">
              <img 
                src={isScrolled ? "/assets/img/brand/logo-light.png" : "/assets/img/brand/logo-light.png"}
                alt="Trademark Liberty" 
                className="h-12 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="/"
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              Home
            </a>
            <a
              href="/about"
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              About Us
            </a>
            
            {/* Services Mega Menu */}
            <div
              className="relative"
              onMouseEnter={() => setIsMegaMenuOpen(true)}
            >
              <button className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium flex items-center space-x-1">
                <span>Services</span>
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isMegaMenuOpen ? 'rotate-180' : ''}`} />
              </button>
            </div>

            <a
              href="/resources"
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              Resources
            </a>
            <a
              href="/contact"
              className="text-white hover:text-[#D4AF37] transition-colors duration-200 font-medium"
            >
              Contact
            </a>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              onClick={onOpenForm}
              className="liquid bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1F44] font-semibold px-6 py-2"
            >
              Free Consultation
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-white hover:text-[#D4AF37] transition-colors"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#0A1F44] py-4 space-y-3">
            <a href="/" className="block px-4 py-2 text-white hover:text-[#D4AF37] transition-colors">
              Home
            </a>
            <a href="/about" className="block px-4 py-2 text-white hover:text-[#D4AF37] transition-colors">
              About Us
            </a>
            <div className="px-4 py-2">
              <div className="text-white font-medium mb-2">Services</div>
              <div className="pl-4 space-y-2">
                {servicesMenu.map((service) => (
                  <a
                    key={service.id}
                    href={`/services/${service.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="block py-1 text-gray-300 hover:text-[#D4AF37] transition-colors text-sm"
                  >
                    {service.name}
                  </a>
                ))}
              </div>
            </div>
            <a href="/resources" className="block px-4 py-2 text-white hover:text-[#D4AF37] transition-colors">
              Resources
            </a>
            <a href="/contact" className="block px-4 py-2 text-white hover:text-[#D4AF37] transition-colors">
              Contact
            </a>
            <div className="px-4 pt-2">
              <Button 
                onClick={onOpenForm}
                className="liquid w-full bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1F44] font-semibold"
              >
                Free Consultation
              </Button>
            </div>
          </div>
        )}

        {/* Mega Menu */}
        <MegaMenu 
          isOpen={isMegaMenuOpen} 
          onClose={() => setIsMegaMenuOpen(false)} 
        />
      </div>
    </nav>
  );
};